<app-item-content [instructionItemContentTemplate]="itemContentBoxes" [row]="row" [startLabel]="startLabel" [endLabel]="endLabel"></app-item-content>
<ng-template #itemContentBoxes let-instruction="instruction">
	<app-instruction-box>{{ getMethodName(instruction.method) }}</app-instruction-box>
	<app-instruction-box>{{ instruction.area }}</app-instruction-box>
</ng-template>
